import React, { useState } from 'react';
import './Biomarkers.css';
// eslint-disable-next-line import/no-cycle
import app from 'new-ui/app';
import PropTypes from 'prop-types';
import { POPUP } from 'utils/constants/popup';
import Button from 'new-ui/Components/Button';
import { THEMES } from 'new-ui/constants';
import { UPLOADER_STATES } from 'new-ui/Components/FilesUploader/FileUploaderConstants';
import { useTranslation } from 'utils/modifiedTranslation';
import { CLIENT_IM_NOT_SURE } from 'new-ui/Components/Intake';
import { getUserCondition } from 'modules/user/utils';
import uploadWhiteIcon from 'assets/icons/upload_white.svg';
import { BulletButton } from '../SingleOptionSelect';

const Biomarkers = (props) => {
  const {
    user,
    onselect,
    resetIntake,
  } = props;
  const [biomarkers, setBiomarkers] = useState(user?.condition_profile?.biomarkers ?? []);
  const controller = {};
  const { t } = useTranslation();

  const isNoneSelected = () => biomarkers?.length === 1 && biomarkers[0] === 'none';

  const handleAnswerManually = () => {
    app.setPopup(POPUP.BIOMARKERS, {
      biomarkers,
      onSelect: (newBiomarkers) => {
        const nextBiomarkers = [...newBiomarkers];
        onselect(nextBiomarkers);
        setBiomarkers(newBiomarkers);
        if (controller?.uploader?.setFiles) {
          controller.uploader.setFiles([]);
        }
        if (controller?.uploader?.setState) {
          controller.uploader.setState(UPLOADER_STATES.SELECT);
        }
      },
    });
  };

  const handleUploadFile = () => {
    app.setPopup(POPUP.UPLOAD, {
      theme: 'middle',
      preventOverlayClose: true,
      condition: getUserCondition(user),
      presentNgsNotFound: true,
      onSuccess: async ({ condition_profile }) => {
        // !!! user mutation
        user.condition_profile = condition_profile;
        onselect(condition_profile.biomarkers);
        resetIntake();
      },
    });
  };

  return (
    <div className="biomarkers-question">
      <div className="biomarkers-question-actions">
        <Button
          action={handleUploadFile}
          title="Upload File"
          forwardIcon={uploadWhiteIcon}
          theme={THEMES.ORANGE_FULL}
          style={{
            height: 'unset',
            alignSelf: 'stretch',
          }}
        />
        <Button
          action={handleAnswerManually}
          title="Update without uploading"
          theme={THEMES.ORANGE}
          style={{
            maxWidth: 'max-content',
            height: 'unset',
            alignSelf: 'stretch',
          }}
        />
      </div>
      {
        biomarkers.length ? null : (
          <div className="multi-pages-submenu margin-top-10">
            <BulletButton
              label={t('questionnaire.biomarkers.skip')}
              isSelected={isNoneSelected()}
              action={() => onselect(['none'])}
            />
            <BulletButton
              label={t('intake.im_not_sure')}
              action={() => onselect(CLIENT_IM_NOT_SURE)}
            />
          </div>
        )
      }
    </div>
  );
};

Biomarkers.propTypes = {
  user: PropTypes.object.isRequired,
  onselect: PropTypes.func.isRequired,
  resetIntake: PropTypes.func.isRequired,
};

export default Biomarkers;
